import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { StickyMobileCTA } from './StickyMobileCTA';
export function Layout() {
  return <div className="min-h-screen flex flex-col" data-id="element-181">
      <Header data-id="element-182" />
      <main className="flex-grow" data-id="element-183">
        <Outlet data-id="element-184" />
      </main>
      <Footer data-id="element-185" />
      <StickyMobileCTA data-id="element-186" />
    </div>;
}